import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FranchiseService } from './franchise.service';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import { FormValidator } from '../form.validator';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;

@Component({
    selector: 'app-addschool',
    templateUrl: './addschool.component.html',
    styleUrls: [
        './../../assets/css/theme-default/bootstrap.css',
        './../../assets/css/theme-default/materialadmin.css',
        './../../assets/css/theme-default/font-awesome.min.css',
        './../../assets/css/theme-default/material-design-iconic-font.min.css',
        /* './../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
        './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
        './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
        './../../_crop/css/style.css',
        './../../_crop/css/style-example.css',
        './addschool.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [FranchiseService, FormValidator, LoginService, Offcanvas, ScriptLoader]
})


export class AddSchoolComponent implements OnInit {

    brand = this.brandService.brand;
    constructor(private FranchiseService: FranchiseService, private router: Router,
        private loginservice: LoginService, private formValidator: FormValidator,
        private offcanvas: Offcanvas, private scriptLoader: ScriptLoader, private brandService: BrandService) {
    }

    public static gAcademicId = 0;

    getAuthToken = localStorage.getItem('usertoken');
    getSchoolId = localStorage.getItem('schoolinfo');
    getSchoolName = localStorage.getItem('franchiseName');
    getCurrency = localStorage.getItem('currency');
    preLoader = true;
    todayDate;
    getSchoolImage;
    accountType;
    loginMode = '';
    getSchoolListArray = [];
    bluewingsftrelst = [];
    currentSchoolId;
    dataSource;

    regform = true;
    emailconfirm = false;
    signinemail = false;
    signinWithEmailData = '';
    resendOtpTrials = 0;

    registerName;
    registerSchoolName;
    registerSchoolCountry;
    registerSchooolEmail;
    registerSchoolContact;
    registerSchoolAreaPinCode;
    registerSchoolUrl;
    registerSchoolUsername;
    registerSchoolPassword;
    registerSchoolVerificationCodeGet;
    registerSchoolDescription;
    registerSchoolState;
    registerSchoolLocality;
    registerSchoolAddress;
    resourceFeeType;
    resourseFee;

    invalidregisterName = false;
    invalidregisterSchoolName = false;
    invalidregisterSchoolCountry = false;
    invalidregisterSchooolEmail = false;
    invalidregisterSchoolContact = false;
    invalidregisterSchoolAreaPinCode = false;
    invalidregisterSchoolUrl = false;
    invalidregisterSchoolUsername = false;
    invalidregisterSchoolPassword = false;
    invalidregisterSchoolState = false;
    invalidregisterSchoolLocality = false;
    invalidregisterSchoolAddress = false;
    invalidregisterSchooolEmail2 = false;
    invalidregisterSchoolUsername2 = false;
    invalidVerificationCode = false;
    invalidSignUpEmail = false;
    regLoader = false;

    invalidresourceFeeType = false;
    invalidresourseFee = false;



    navigateTo(path, data) {
        this.router.navigate(['/' + path], { state: { tab: data } });
    }

    getProperNumber(num) {
        return num < 10 ? '0' + num : num;
    }

    // get today date
    getTodayDate() {
        const getDateNow = new Date();
        const getMonth = getDateNow.getUTCMonth() + 1;
        const getDay = getDateNow.getUTCDate();
        const getYear = getDateNow.getUTCFullYear();

        this.todayDate = getYear + '/' + getMonth + '/' + getDay;

    }

    // string wrap to words function - getWords(str,5);
    getWords(str, count) {
        return str.split(/\s+/).slice(0, count).join(' ');
    }

    //validating form data for adding the school
    proceedRegister() {
        this.invalidregisterSchoolName = false;
        this.invalidregisterSchoolCountry = false;
        this.invalidregisterSchooolEmail = false;
        this.invalidregisterSchoolContact = false;
        this.invalidregisterSchoolAreaPinCode = false;
        this.invalidregisterSchoolUrl = false;
        this.invalidregisterSchoolUsername = false;
        this.invalidregisterSchoolPassword = false;
        this.invalidregisterSchoolState = false;
        this.invalidregisterSchoolLocality = false;
        this.invalidregisterSchoolAddress = false;
        this.invalidregisterSchoolUsername2 = false;
        this.invalidregisterSchooolEmail2 = false;

        this.invalidresourceFeeType = false;
        this.invalidresourseFee = false;

        if (!this.formValidator.validateIsData(this.registerSchoolName) || $.isNumeric(this.registerSchoolName)) {
            this.invalidregisterSchoolName = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchooolEmail)) {
            this.invalidregisterSchooolEmail = true;
        } 
        else if (!this.formValidator.validateIsEmail(this.registerSchooolEmail)) {
            this.invalidregisterSchooolEmail = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolContact)) {
            this.invalidregisterSchoolContact = true;
        } 
        else if (!this.formValidator.validateMobileNumber(this.registerSchoolContact)) {
            this.invalidregisterSchoolContact = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolCountry)) {
            this.invalidregisterSchoolCountry = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolState)) {
            this.invalidregisterSchoolState = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolLocality)) {
            this.invalidregisterSchoolLocality = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolAddress)) {
            this.invalidregisterSchoolAddress = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolAreaPinCode)) {
            this.invalidregisterSchoolAreaPinCode = true;
        } 
        else if (!$.isNumeric(this.registerSchoolAreaPinCode)) {
            this.invalidregisterSchoolAreaPinCode = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolUrl)) {
            this.invalidregisterSchoolUrl = true;
        } 
        else if (this.registerSchoolUrl.length < 3) {
            this.invalidregisterSchoolUrl = true;
        } 
        else if (/[-!$%^&*()_+|~=`{}\[\]:";'<>?,. \/]/.test(this.registerSchoolUrl)) {
            this.invalidregisterSchoolUrl = true;
        } 
        else if (!this.formValidator.validateIsData(this.resourceFeeType)) {  //resource fee type
            this.invalidresourceFeeType = true;
        }
        else if (!$.isNumeric(this.resourseFee)) { //resource fee 
            this.invalidresourseFee = true;
        }
        else if (!this.formValidator.validateIsData(this.registerSchoolUsername)) {
            this.invalidregisterSchoolUsername = true;
        } 
        else if (/[-!$%^&*()_+|~=`{}\[\]:";'<>?,. \/]/.test(this.registerSchoolUsername)) {
            this.invalidregisterSchoolUsername = true;
        } 
        else if (this.registerSchoolUsername.length < 3) {
            this.invalidregisterSchoolUsername = true;
        } 
        else if (!this.formValidator.validateIsData(this.registerSchoolPassword)) {
            this.invalidregisterSchoolPassword = true;
        } 
        else if (this.registerSchoolPassword.length < 6) {
            this.invalidregisterSchoolPassword = true;
        } 
        else {

            this.regLoader = true;

            // check the school url is valid
            this.FranchiseService.isExcitingUrl(this.registerSchoolUrl).subscribe(
                (data: any) => {
                    if (data.isDomainExist === false) {

                        //this.regform = false;
                        this.emailconfirm = true;
                        this.signinemail = false;
                        this.resendOtpTrials = 0;
                        //this.registerSchool();
                        setTimeout(() => this.registerSchool(), 1000);
                    }
                    else {
                        this.regLoader = false;
                        this.invalidregisterSchoolUrl = true;
                    }
                },
                error => {

                }
            );
        }
    }

    // passing validated data to register school API
    registerSchool() {
        this.resendOtpTrials++;
        this.regLoader = true;
        this.invalidVerificationCode = false;

        const yourname = this.getSchoolName;
        const phoneNumber = this.registerSchoolContact;
        const domainName = this.registerSchoolUrl;
        const schoolName = this.registerSchoolName + " " + this.getSchoolName;
        const description = this.registerSchoolDescription;
        const state = this.registerSchoolState;
        const locality = this.registerSchoolLocality;
        const pincode = this.registerSchoolAreaPinCode;
        const address = this.registerSchoolAddress;
        const accountType = 'Trial';
        const emailId = this.registerSchooolEmail;
        const password = this.registerSchoolPassword;
        const username = this.registerSchoolUsername;
        const country = this.registerSchoolCountry;
        //const emailVerificationCode = this.registerSchoolVerificationCodeGet;
        
        const resourceFeeType = this.resourceFeeType;
        const resourceFeeValue = this.resourseFee;

        // console.log("resourceFeeType", resourceFeeType);
        // console.log("resourceFeeValue", resourceFeeValue);
        // customToastr("School successfully added", 'success');
        // this.regLoader = false;



        this.FranchiseService.registerSchool(domainName, schoolName, description, state, locality,
            pincode, address, accountType, emailId, password, username, yourname, phoneNumber, country, resourceFeeType, resourceFeeValue, this.getAuthToken)
            .subscribe(
                (data: any) => {

                    if (data.errorcode === undefined && data.status === true) {
                        customToastr("School successfully added", 'success');
                        this.regLoader = false;
                        $("#formReg")[0].reset();
                        //window.open('https://www.youtube.com/', '_blank');
                    } else {
                        customToastr("Failed to add school,</br>please try again", 'error');
                        this.regLoader = false;
                    }
                },
                error => {
                }
            );
    }


    // token auth
    isValidToken() {
        let isValidToken = false;
        let isValidSchool = 0;
        this.loginservice.isValidToken(this.getAuthToken).subscribe(
            (data: any) => {
                isValidToken = data.isValid;
                if (data.errorcode === 10010) {
                    this.router.navigate(['/suspended']);
                } else if (isValidToken === true) {

                    this.loginservice.isValidSchoolId(this.getSchoolId).subscribe(
                        (validData: any) => {
                            isValidSchool = validData.schoolExist;
                            if (isValidSchool !== 1) {
                                this.router.navigate(['/login']);
                            }
                            else {
                                if (this.loginMode === 'STAFF') {
                                    this.router.navigate(['/exams']);
                                }
                                // else {

                                // }
                            }
                        },
                        error => {
                        }
                    );
                } else {
                    this.router.navigate(['/login']);
                }
            },
            error => {
            }
        );
    }

    initScripts() {
        this.scriptLoader.loadScript($, 'DASHBOARD');
    }

    ngOnInit() {
        $('.after').empty();
        $('.after').append('<script>function customToastr(message,type,title){toastr.options.hideDuration = 0;toastr.clear();' +
            'toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;' +
            'toastr.options.positionClass = \'toast-top-right\';toastr.options.showDuration = 330;' +
            'toastr.options.hideDuration = 330;toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;' +
            'toastr.options.showEasing = \'swing\';toastr.options.hideEasing = \'swing\';toastr.options.showMethod = \'slideDown\';' +
            'toastr.options.hideMethod = \'slideUp\';toastr[type](message, title || \'\');return 0;}	</' + 'script>');
        this.isValidToken();

        setTimeout(() => this.initScripts(), 500);
    }

}
